import { useState } from "react";
import { PageHeader, GlassCard, EmptyState, useCrud, ItemDialog, RowActions } from "../_shared";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const FIELDS = [
  { key: "q", label: "Question", required: true },
  { key: "a", label: "Answer", required: true, type: "textarea", rows: 4 },
  { key: "enabled", label: "Visible on site", type: "switch" },
];

export default function FaqsManager() {
  const { items, loading, busy, create, update, remove, move } = useCrud("/admin/cms/faqs");
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const openNew = () => { setEditing({ enabled: true }); setOpen(true); };
  const openEdit = (it) => { setEditing(it); setOpen(true); };
  const submit = async (form) => {
    if (editing?.id) await update(editing.id, form); else await create(form);
    setOpen(false);
  };

  return (
    <>
      <PageHeader
        title="Frequently Asked Questions"
        subtitle="Q&A shown in the accordion on Home and /faq pages."
        actions={<Button onClick={openNew} className="bg-[#0057B8] hover:bg-[#003F87] text-white rounded-full" data-testid="new-faq-btn"><Plus className="w-4 h-4 mr-1" /> New FAQ</Button>}
      />
      {loading ? <div className="text-slate-500">Loading…</div> : items.length === 0 ? (
        <EmptyState label="No FAQs yet." action={<Button onClick={openNew}>Add first FAQ</Button>} />
      ) : (
        <div className="space-y-3">
          {items.map((it, i) => (
            <GlassCard key={it.id} className="p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="font-display font-semibold text-slate-900">{it.q}</div>
                  <div className="text-sm text-slate-500 mt-1">{it.a}</div>
                </div>
                <div className="flex items-center gap-2">
                  {!it.enabled && <span className="text-[10px] font-semibold bg-slate-200 text-slate-600 px-2 py-0.5 rounded-full">Hidden</span>}
                  <RowActions
                    onEdit={() => openEdit(it)} onDelete={() => remove(it.id)}
                    onUp={() => move(it.id, "up")} onDown={() => move(it.id, "down")}
                    canUp={i > 0} canDown={i < items.length - 1}
                  />
                </div>
              </div>
            </GlassCard>
          ))}
        </div>
      )}
      <ItemDialog
        open={open} onOpenChange={setOpen}
        title={editing?.id ? "Edit FAQ" : "New FAQ"}
        fields={FIELDS}
        initial={editing || { enabled: true }}
        onSubmit={submit}
        submitting={busy}
      />
    </>
  );
}
